<div *ngIf="false" class="sidebar">
    <div class="logopanel">
        <h1>
            <a [routerLink]="['/dashboard']"></a>
        </h1>
    </div>
    <div class="sidebar-inner">
        <div class="sidebar-top">
            <div class="userlogged clearfix">
                <i class="icon icons-faces-users-01"></i>
                <div class="user-details">
                    <h4>{{ user.Username }}</h4>
                    <div class="dropdown user-login">
                        <div class="btn btn-xs btn-rounded" style="cursor: auto;">
                            <i class="online"></i><span>Disponibile</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="nav nav-sidebar" style="margin-top: 40px;">
            <li [routerLinkActive]="['nav-active', 'active']" class="nav-parent" style="width: 100%;">
                <a [routerLink]="['/dashboard']"><i class="icon-home"></i><span>Dashboard</span></a>
            </li>
            <li [routerLinkActive]="['nav-active', 'active']" class="nav-parent">
                <a href=""><i class="icon-user"></i><span>Utenti </span><span class="fa arrow"></span></a>
                <ul class="children collapse">
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/user']"> Generale</a>
                    </li>
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/user/create']"> Crea Nuovo Utente</a>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="sidebar-footer clearfix">
            <a class="pull-left footer-settings" routerLink="/user/settings" data-rel="tooltip" data-placement="top" data-original-title="Impostazioni">
                <i class="icon-settings"></i></a>
            <a class="pull-left toggle_fullscreen" href="#" data-rel="tooltip" data-placement="top" data-original-title="Fullscreen">
                <i class="icon-size-fullscreen"></i></a>
            <a class="pull-left" href="user-lockscreen.html" data-rel="tooltip" data-placement="top" data-original-title="Lockscreen">
                <i class="icon-lock"></i></a>
            <a (click)="signOut($event)" class="pull-left btn-effect" style="cursor: pointer;" data-modal="modal-1" data-rel="tooltip" data-placement="top" data-original-title="Logout">
                <i class="icon-power"></i></a>
        </div>
    </div>
</div>
<div class="test">
    <div class="logo">
        <img src="/assets/global/images/logo/logo-tevanpal.png">
    </div>
</div>
